import React, { useEffect, useState, useContext, createContext } from "react";

const OnboardingContext = createContext({});

export const OnboardingProvider = ({ children }) => {
  const [areaCode, setAreaCode] = useState('');
  const [verificationPhone, setVerificationPhone] = useState("");

  useEffect(() => {}, [false]);
  return (
    <OnboardingContext.Provider
      value={{ areaCode, setAreaCode, verificationPhone, setVerificationPhone }}
    >
      {children}
    </OnboardingContext.Provider>
  );
};

export default OnboardingContext;
